import React from 'react';
import {observer} from 'mobx-react';
import {ObjectSelect2, SearchableDropdownSelect} from 'components';
import _ from 'lodash';
import {auth} from "shared/core";

const SelectedAssignee = observer(({uiState}) => {
  const {selectedAssigneeOptions} = uiState;

  return (
    <div className='flex align-items-middle'>
      <div className='mr1' style={{width: '1rem', height: '1rem', backgroundColor: uiState.selectedAssignee.color || '#C9CFD1', borderRadius: '100%'}}/>
      <div className='flex-grow'>
        <ObjectSelect2
          value={uiState.selectedAssignee}
          by='assignee'
          onChange={value => uiState.selectedAssignee = value}
          disabled={selectedAssigneeOptions.length === 1}
          items={selectedAssigneeOptions}
        />
      </div>
    </div>
  );
});

const Signatures = observer(({uiState}) => {
  return (
    <SearchableDropdownSelect
      label='components.pdf.annotate.toolbar.Company Signatures'
      onSelect={signature => uiState.addAnnotation(signature, uiState.selectedAssignee)}
      options={uiState.signatures}
    />
  );
});

const MergeFields = observer(({uiState}) => {
  return (
    <SearchableDropdownSelect
      label={'components.pdf.annotate.toolbar.Dynamic Fields'}
      onSelect={(field) => uiState.addAnnotation(field, uiState.selectedAssignee)}
      optionCategories={uiState.mergeFields}
    />
  );
});

const InputFields = observer(({uiState}) => {
  return (
    <SearchableDropdownSelect
      label='components.pdf.annotate.toolbar.Forms'
      onSelect={field => uiState.addAnnotation(field, uiState.selectedAssignee)}
      options={uiState.inputFields}
    />
  );
});

const Toolbar = observer(({uiState}) => {
  const {signatures} = uiState;

  return (
    <div className='flex align-items-middle relative mb3' style={{width: 798}}>
      <div className='flex-grow mr2'>
        <SelectedAssignee uiState={uiState}/>
      </div>
      <div className='border-right border--submarine mr2' style={{height: 30}}/>
      <div className='mr2'>
        <MergeFields uiState={uiState}/>
      </div>
      <div>
        <InputFields uiState={uiState}/>
      </div>
      {!_.isEmpty(signatures) && <>
        <div className='border-right border--submarine mx2' style={{height: 30}}/>
        <div>
          <Signatures uiState={uiState}/>
        </div>
      </>}
    </div>
  );
});

export default Toolbar;
